<script setup lang="ts">
import { type Props } from './types';

withDefaults(defineProps<Props>(), {
  modelValue: false,
  disabled: false,
  text: '',
  inheritAttrs: false,
});

const emit = defineEmits(['update:modelValue']);

const selectHandler = (e: Event) => {
  const target = e.target as HTMLInputElement;
  emit('update:modelValue', target.checked);
};
</script>

<template>
  <div :class="['checkbox', { _disabled: disabled }]">
    <label class="checkbox__label">
      <input
        type="checkbox"
        :checked="modelValue"
        class="checkbox__input"
        @input="selectHandler"
      />
      <span v-if="text" class="checkbox__text">{{ text }}</span>
    </label>
  </div>
</template>

<style lang="less">
.checkbox {
  &__label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__input {
    display: none;

    &:checked + .checkbox__text::before {
      background-color: @color-tango;
      border-color: @color-tango;
      background-image: url('/images/icons/checked.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 14px 10px;
    }
  }

  &__text {
    position: relative;
    font-size: @size-x4;
    font-weight: 500;
    line-height: 130%;
    word-break: break-word;
    padding-left: @size-x7;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: @size-x5;
      height: @size-x5;
      border: 2px solid @color-alto;
      border-radius: @main-size;
      transition: all 0.2s;
    }
  }
}
</style>
